import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import React, {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import './DeleteAlertStyles.scss';

interface IDeleteAlterProps {
  title: string;
  description?: ReactNode;
  open: boolean;
  close: (res: 'cancel' | 'confirm') => void;
}
const DeleteAlert = (props: IDeleteAlterProps): React.ReactElement => {
  const {open, close, description, title} = props;
  const {t} = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={() => close('cancel')}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      fullWidth={false}
      maxWidth={'md'}
      className="delete-alert-dialog">
      <DialogTitle disableTypography>{title}</DialogTitle>
      <DialogContent dividers>{description}</DialogContent>
      <DialogActions>
        <Button onClick={() => close('cancel')}>{t('ADD_PATIENT.NO')}</Button>
        <Button className="danger-button" onClick={() => close('confirm')}>
          {t('ADD_PATIENT.YES')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAlert;
